var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_phone_lineal_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.824,
    height: 64.554,
    viewBox: "0 0 44.824 64.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85493",
    "data-name": "Rect\\xE1ngulo 85493",
    width: 6,
    height: 5,
    rx: 2,
    transform: "translate(37.693 11.337)",
    fill: "#fecebf"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85494",
    "data-name": "Rect\\xE1ngulo 85494",
    width: 8,
    height: 5,
    rx: 2.5,
    transform: "translate(35.693 17.337)",
    fill: "#fecebf"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85495",
    "data-name": "Rect\\xE1ngulo 85495",
    width: 8,
    height: 6,
    rx: 3,
    transform: "translate(35.693 22.337)",
    fill: "#fecebf"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85496",
    "data-name": "Rect\\xE1ngulo 85496",
    width: 8,
    height: 5,
    rx: 2.5,
    transform: "translate(35.693 28.337)",
    fill: "#fecebf"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85497",
    "data-name": "Rect\\xE1ngulo 85497",
    width: 21.482,
    height: 8.183,
    rx: 4.092,
    transform: "translate(5.787 43.578) rotate(45)",
    fill: "#b1e0de"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104968",
    "data-name": "Trazado 104968",
    d: "M7126.548,1956.859l2.509-2.35v-21.936s-.255-3.187,2.659-3.415a2.684,2.684,0,0,1,3.15,2.331v12.144a8.622,8.622,0,0,1,4.666,4.607,13.057,13.057,0,0,1,.448,9.5c.1.033,11.319,0,11.319,0l-1.687,2.583a11.706,11.706,0,0,1-10.08,4.171c-.013.049-3.008,2.819-3.008,2.819Z",
    transform: "translate(-7119.141 -1911.607)",
    fill: "#fecebf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104967",
    "data-name": "Trazado 104967",
    d: "M7140.19,1951.107h19.392v2.968s-.238,3.2-3.223,3.236-17.325-.245-17.325-.245a6.227,6.227,0,0,0,1.156-3.349A17.86,17.86,0,0,0,7140.19,1951.107Z",
    transform: "translate(-7118.854 -1911.103)",
    fill: "#fc287e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104966",
    "data-name": "Trazado 104966",
    d: "M7134.874,1917.124h24.838s.621-4.434-3.032-4.42-19.429,0-19.429,0-2.326.566-2.377,2.626C7134.894,1915.321,7134.874,1917.124,7134.874,1917.124Z",
    transform: "translate(-7118.95 -1911.984)",
    fill: "#fc287e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smartphone",
    transform: "translate(0.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75943",
    "data-name": "Trazado 75943",
    d: "M76.223,30.668a3.631,3.631,0,0,0-1.213-2.71,3.683,3.683,0,0,0,0-5.431,3.683,3.683,0,0,0,0-5.431,3.678,3.678,0,0,0-1.966-6.332V3.726A3.73,3.73,0,0,0,69.318,0H57.54a.93.93,0,0,0,0,1.859H69.318a1.869,1.869,0,0,1,1.867,1.867v.492H48.234V3.726A1.869,1.869,0,0,1,50.1,1.859H52.46A.93.93,0,0,0,52.46,0H50.1a3.731,3.731,0,0,0-3.726,3.726V17.334a3.917,3.917,0,0,0-5.951,3.287v21.8l-1.741,1.748a5.057,5.057,0,0,0-5.7,8.166l5.754,5.78A.93.93,0,0,0,40.057,56.8L34.3,51.022a3.193,3.193,0,1,1,4.5-4.527l9.6,9.64a3.215,3.215,0,0,1,0,4.527,3.285,3.285,0,0,1-4.869-.366.93.93,0,0,0-1.318,1.312,5.065,5.065,0,0,0,8.118-6.037l1.675-1.682a12.652,12.652,0,0,0,12.172-6.909h5.136a3.73,3.73,0,0,0,3.726-3.726V34.29A3.648,3.648,0,0,0,76.223,30.668Zm-1.859.012a1.782,1.782,0,0,1-1.78,1.78H70.961a1.786,1.786,0,0,1,0-3.572h1.623A1.785,1.785,0,0,1,74.364,30.68Zm0-5.431a1.782,1.782,0,0,1-1.78,1.78H70.961a1.786,1.786,0,0,1,0-3.572h1.623a1.785,1.785,0,0,1,1.78,1.792Zm0-5.431a1.782,1.782,0,0,1-1.78,1.78H70.961a1.786,1.786,0,0,1,0-3.572h1.623a1.785,1.785,0,0,1,1.78,1.792Zm0-5.444a1.833,1.833,0,0,1-1.78,1.792H70.961a1.786,1.786,0,0,1,0-3.572h1.623a1.782,1.782,0,0,1,1.78,1.78Zm-3.179-8.3v4.657A3.657,3.657,0,0,0,68.534,17.1a3.661,3.661,0,0,0,0,5.431,3.661,3.661,0,0,0,0,5.431,3.657,3.657,0,0,0,2.651,6.361v4.657H53.559a10.732,10.732,0,0,0-5.326-7.667V6.077Zm-18.2,46-1.3-.061a.938.938,0,0,0-.7.273l-1.894,1.9-8.878-8.919,1.8-1.81a.93.93,0,0,0,.271-.656V20.621a2.019,2.019,0,0,1,4.037,0V31.868a.93.93,0,0,0,.56.853,8.375,8.375,0,0,1,4.614,5.588,10.427,10.427,0,0,1-1.194,8.6.93.93,0,0,0,1.532,1.054,10.042,10.042,0,0,0,.594-.981h9.633a10.594,10.594,0,0,1-9.071,5.094ZM69.318,45.12H53.2a12.65,12.65,0,0,0,.564-4.285H71.185v2.418A1.869,1.869,0,0,1,69.318,45.12Z",
    transform: "translate(-31.514 0)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75944",
    "data-name": "Trazado 75944",
    d: "M185.86,74.833a.929.929,0,0,0,1.314-.017l2.721-2.793a.93.93,0,0,0-1.332-1.3l-2.721,2.793A.93.93,0,0,0,185.86,74.833Z",
    transform: "translate(-166.484 -61.711)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75945",
    "data-name": "Trazado 75945",
    d: "M185.86,80.809a.929.929,0,0,0,1.314-.017l8.543-8.77a.93.93,0,0,0-1.332-1.3l-8.543,8.77A.93.93,0,0,0,185.86,80.809Z",
    transform: "translate(-166.484 -61.711)",
    fill: "#3b0310"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.892d854b3e5cea7cc8472d73187cfe88.svg";
export { ForwardRef as ReactComponent };